const TEMPO_ID = 'tempo-'

export { TEMPO_ID }
